import * as React from "react";
import { SVGProps, memo } from "react";
const SvgEmbeddedDatasource = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="embedded-datasource_svg__Layer_1"
    x={0}
    y={0}
    xmlSpace="preserve"
    width={16}
    height={16}
    role="img"
    {...props}
  >
    <style>{".embedded-datasource_svg__st0{fill:#666}"}</style>
    <path
      className="embedded-datasource_svg__st0"
      d="M5.5 0C2.5 0 0 1.3 0 3v9c0 1.4 1.7 2.5 4 2.9v-1c-1.8-.3-3-1-3-1.9V4.7C2 5.5 3.6 6 5.5 6S9 5.5 10 4.7V8h1V3c0-1.7-2.5-3-5.5-3zm0 5C3 5 1 4.1 1 3s2-2 4.5-2 4.5.9 4.5 2-2 2-4.5 2z"
    />
    <path
      className="embedded-datasource_svg__st0"
      d="M6 15c-.1 0-.3 0-.4-.1l-2.5-2.5c-.2-.2-.2-.5 0-.7l2.5-2.5c.2-.2.6-.2.8 0s.2.5 0 .7L4.2 12l2.1 2.1c.2.2.2.5 0 .7 0 .2-.2.2-.3.2zM12 15c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l2.1-2.1-2.1-2.1c-.2-.2-.2-.5 0-.7s.5-.2.7 0l2.5 2.5c.2.2.2.5 0 .7L12.3 15H12zM7.5 15c-.1 0-.2 0-.3-.1-.2-.1-.3-.4-.2-.7l3.1-5c.1-.2.5-.3.7-.2.2.1.3.5.2.7l-3.1 5c-.1.2-.3.3-.4.3z"
    />
  </svg>
);
const Memo = memo(SvgEmbeddedDatasource);
export default Memo;
